import { useEffect } from 'react';
import { getRedirectResult } from 'firebase/auth';
import { auth } from '../firebase/config';
import { useNavigate } from 'react-router-dom';

const AuthHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleRedirectResult = async () => {
      try {
        console.log('AuthHandler: Checking redirect result...');
        const result = await getRedirectResult(auth);
        
        if (result && result.user) {
          console.log('✅ AuthHandler: Sign-in successful!', result.user.email);
        } else {
          console.log('AuthHandler: No redirect result');
        }
        
        // Always redirect back to home
        navigate('/', { replace: true });
      } catch (error) {
        console.error('❌ AuthHandler: Error:', error);
        navigate('/?error=' + encodeURIComponent(error.message), { replace: true });
      }
    };

    handleRedirectResult();
  }, [navigate]);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      color: 'white',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{
          border: '4px solid rgba(255,255,255,0.3)',
          borderTop: '4px solid white',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px'
        }}></div>
        <p>Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthHandler;
